import { memoizedCreateCartFlowForCompletedOrders, DEFAULT_CONFIG_VALUES } from './cartFlowFactory';

export const useCartFlowForCompletedOrders = (order) => {
  if (!order?.cart) {
    return DEFAULT_CONFIG_VALUES;
  }

  return memoizedCreateCartFlowForCompletedOrders({ cart: order.cart });
};
